<template>
  <div class="container pt-3 pb-4">
    <my-orders></my-orders>
  </div>
</template>

<script>
  import MyOrders from '../order/MyOrders'

  export default {
    components: {
      MyOrders
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/lineLiff/Booking.vue